import { getImageFilename, getImageUrl } from './image';
var MAX_THUMBNAIL_WIDTH = 640;
var MAX_THUMBNAIL_HEIGHT = 480;
export var resizeThumbnail = function (imageHost) { return function (pathname, width, height) { return ({
    url: getImageUrl(imageHost)({
        file_name: getImageFilename(pathname),
        width: width,
        height: height,
    }, {
        maxWidth: MAX_THUMBNAIL_WIDTH,
        maxHeight: MAX_THUMBNAIL_HEIGHT,
    }),
    width: MAX_THUMBNAIL_WIDTH,
    height: MAX_THUMBNAIL_HEIGHT,
}); }; };
//# sourceMappingURL=thumbnail.js.map